module.exports = __webpack_public_path__ + "static/media/icon_point.ced63440.svg";